import { render, staticRenderFns } from "./RequestActions.vue?vue&type=template&id=68d9284a&"
import script from "./RequestActions.vue?vue&type=script&lang=ts&"
export * from "./RequestActions.vue?vue&type=script&lang=ts&"
import style0 from "./RequestActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
